export default __webpack_public_path__ + "static/1195-dc1af7aea9ec9ae35046183da6feb96c.gif";